export interface CxoneDispositionsData {
    DispositionsRows: CxoneDispostions[];
}

export interface CxoneDispostions {
    Name: string;
    Handled: number;
    Percentage: number;
    AHT: string;
    GroupID: number;
    GroupName: string | null;
}

export enum ModuleView {
    Table = "table",
    Chart = "chart",
    Table_and_Chart = "table_and_chart",
}